import TocContents from '~/components/content/toc-contents';
import { Footer } from '~/components/layout/footer';
import { PublicNavbar } from '~/components/layout/public-navbar';
import RandomBackground from '~/components/layout/random-background';

export default function PrivacyPolicy() {
  return (
    <div>
      <RandomBackground>
        <PublicNavbar hideSignIn />

        <div className="relative z-10 border-b-4 border-b-secondary px-4 pb-6 pt-2 tablet:px-20 tablet:pb-40 tablet:pt-28 tablet:text-center">
          <h2 className="font-mono text-primary-foreground">Terms of Service</h2>
        </div>
      </RandomBackground>

      <div className="mx-auto my-10 flex max-w-2xl flex-col gap-4 px-4 text-body2 font-light">
        <p>
          PLEASE READ THE FOLLOWING TERMS OF SERVICE AGREEMENT CAREFULLY. BY ACCESSING OR USING OUR
          SITES AND OUR SERVICES, YOU HEREBY AGREE TO BE BOUND BY THE TERMS AND ALL TERMS
          INCORPORATED HEREIN BY REFERENCE. IT IS THE RESPONSIBILITY OF YOU, THE USER, CUSTOMER, OR
          PROSPECTIVE CUSTOMER TO READ THE TERMS AND CONDITIONS BEFORE PROCEEDING TO USE THIS SITE.
          IF YOU DO NOT EXPRESSLY AGREE TO ALL OF THE TERMS AND CONDITIONS, THEN PLEASE DO NOT ACCESS
          OR USE OUR SITES OR OUR SERVICES. THIS TERMS OF SERVICE AGREEMENT IS EFFECTIVE AS OF
          05/30/2024.
        </p>

        <TocContents />
      </div>

      <Footer />
    </div>
  );
}
